<template>
  <svg viewBox="-13.13 -13.63 210.26 210.26" fill="none" aria-hidden="true">
    <rect x="-13.13" y="-13.63" width="210.26" height="210.26" fill="#0E0E0E" />
    <rect x="33" y="33" width="24" height="23" fill="#FFAF01" />
    <rect x="33" y="56" width="47" height="24" fill="#FF8204" />
    <rect x="33" y="80" width="118" height="23" fill="#FA500F" />
    <rect x="127" y="103" width="24" height="24" fill="#E10500" />
    <rect x="80" y="103" width="24" height="24" fill="#E10500" />
    <rect x="33" y="103" width="24" height="24" fill="#E10500" />
    <rect x="104" y="127" width="70" height="23" fill="#C4001D" />
    <rect x="10" y="127" width="70" height="23" fill="#C4001D" />
    <rect x="104" y="56" width="47" height="24" fill="#FF8204" />
    <rect x="127" y="33" width="24" height="23" fill="#FFAF01" />
  </svg>
</template>
